import { render, staticRenderFns } from "./SLAMonitoring.vue?vue&type=template&id=3c8dd99c"
import script from "./SLAMonitoring.vue?vue&type=script&lang=js"
export * from "./SLAMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports